export default {
  header: 'Rückmeldung',
  placeholder: 'Fügen Sie einen Kommentar hinzu...',
};
